import React, { useCallback, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from 'roo-ui/components';
import { getQueryPayWith, getQueryMinPrice, getQueryMaxPrice } from 'store/search/searchSelectors/querySelectors';
import { PAYMENT_METHODS } from 'lib/enums/payment';
import { updateQuery as updateQueryAction } from 'store/search/searchActions';
import PriceFilter from 'components/Filters/Search/PriceFilter';
import PayWith from 'components/Filters/Search/PayWith';

import FilterItem from './FilterItem';

const PriceFilterItem = () => {
  const dispatch = useDispatch();
  const minPrice = useSelector(getQueryMinPrice);
  const maxPrice = useSelector(getQueryMaxPrice);
  const payWith = useSelector(getQueryPayWith);

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  const clearFilters = useCallback(() => {
    updateQuery({ minPrice: undefined, maxPrice: undefined });
  }, [updateQuery]);

  return (
    <FilterItem
      buttonText="Price"
      isHighlighted={minPrice > 0 || maxPrice > 0 || payWith === PAYMENT_METHODS.POINTS}
      clearFilters={clearFilters}
    >
      <Fragment>
        <PayWith onChange={updateQuery} hideClear />
        <Box mt={4}>
          <PriceFilter onChange={updateQuery} />
        </Box>
      </Fragment>
    </FilterItem>
  );
};

export default PriceFilterItem;
